import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'

import { ProjectsWrapper } from '../Components/ProjectsWrapper'
import { AddNewProjectSidebar } from './Sidebar/AddProjectSidebar'
import { ProjectsDetailContent } from '../Components/ProjectDetailContent'

import projectsStore from '../../Store'

export const ProjectDetailDesktop = observer(({ route, navigation }: any) => {
  const {
    stats,
    toggleSideBar,
    invoiceListing,
    getProjectStats,
    isVisibleSidebar,
    getProjectDetail,
    projectDetail,
    receivables,
    payables,
    income,
    expenses,
    refresher,
  } = projectsStore

  const [visibleModal, setVisibleModal] = useState(false)
  const [chosen, setChosen] = useState(null) // chosen item if not empty showing sidebar for edit project

  useEffect(() => {
    getProjectDetail(route?.params?.projectId)
    getProjectStats(route?.params?.projectId)
  }, [refresher, getProjectDetail, getProjectStats, route?.params?.projectId])

  return (
    <ProjectsWrapper
      header={<></>}
      sidebar={
        <AddNewProjectSidebar
          chosen={chosen}
          visibleEdit={visibleModal}
          setChosen={setChosen}
          setVisibleEdit={() => null}
          projectId={route?.params?.projectId}
          visibleSidebar={isVisibleSidebar}
          setVisibleModal={setVisibleModal}
          setVisibleSidebar={toggleSideBar}
          data={invoiceListing}
          navigation={navigation}
        />
      }
      children={
        <ProjectsDetailContent
          pageData={{
            receivables,
            payables,
            income,
            expenses,
            stats,
            customer: (projectDetail as any)?.customer?.name,
            name: (projectDetail as any)?.name,
            company_id: (projectDetail as any)?.company_id,
            invoiceListing,
          }}
          projectId={route?.params?.projectId}
        />
      }
    />
  )
})
